module.exports = __webpack_public_path__ + "9d1c0bcd767f24e75a64a22cbc816fdf.jpg";